import { render, staticRenderFns } from "./SetupStep04.vue?vue&type=template&id=7a266a85&scoped=true&"
import script from "./SetupStep04.vue?vue&type=script&lang=js&"
export * from "./SetupStep04.vue?vue&type=script&lang=js&"
import style0 from "./SetupStep04.vue?vue&type=style&index=0&id=7a266a85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a266a85",
  null
  
)

export default component.exports